<template>
  <div class="cal-shell">
    <div class="cal-skeleton-wrapper">
      <div class="cal-skeleton-header">
        <div class="cal-skeleton-title"></div>
        <div class="cal-skeleton-subtitle"></div>
      </div>
      <div class="cal-skeleton-steps">
        <div class="cal-skeleton-circle"></div><div class="cal-skeleton-line"></div>
        <div class="cal-skeleton-circle"></div><div class="cal-skeleton-line"></div>
        <div class="cal-skeleton-circle"></div><div class="cal-skeleton-line"></div>
        <div class="cal-skeleton-circle"></div>
      </div>
      <div class="cal-skeleton-title" style="width: 120px; margin-bottom: 1rem; align-self: flex-start; height: 18px;"></div>
      <div class="cal-skeleton-cards">
        <div v-for="i in 4" :key="i" class="cal-skeleton-card">
          <div class="cal-skeleton-avatar"></div>
          <div class="cal-skeleton-info">
            <div class="cal-skeleton-text"></div>
            <div class="cal-skeleton-subtext"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { parseUrlData } from '../fun/fun.js'

export default {
  name: 'HomeView',
  async created() {
    const { partner } = parseUrlData(window.location.href);
    const language = this.$route.params.lang || 'eng';
    const partnerParam = this.$route.params.partner;
    
    try {
      const response = await axios.get('https://api.barbersunity.com/data', {
        params: { partner, _t: Date.now() }
      });
      localStorage.removeItem("data");
      localStorage.setItem("data", JSON.stringify({
        payload: response.data,
        expiresAt: Date.now() + 30 * 60 * 1000 // 30 min TTL
      }));
      this.$router.replace(`/${language}/${partnerParam}/calendar`);
    } catch (error) {
      console.error('Error fetching data:', error);
      this.$router.replace('/404'); // Safely redirect to your new 404 page!
    }
  }
}
</script>

<style scoped>
/* Skeleton Shell (Matches CalendarView) */
.cal-shell {
  max-width: 480px;
  margin: 0 auto;
  background: rgba(19, 23, 34, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 20px;
  padding: 1.75rem 1.5rem 1.25rem;
  backdrop-filter: blur(12px);
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.04);
}

.cal-skeleton-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.cal-skeleton-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1.25rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.cal-skeleton-title {
  width: 200px;
  height: 28px;
  border-radius: 8px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.cal-skeleton-subtitle {
  width: 140px;
  height: 16px;
  border-radius: 6px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.cal-skeleton-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
}

.cal-skeleton-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.cal-skeleton-line {
  width: 40px;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.cal-skeleton-cards {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.cal-skeleton-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 12px;
}

.cal-skeleton-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  flex-shrink: 0;
}

.cal-skeleton-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex: 1;
}

.cal-skeleton-text {
  width: 60%;
  height: 16px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.cal-skeleton-subtext {
  width: 40%;
  height: 12px;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>